// extracted by mini-css-extract-plugin
export default {"loginPage":"admin-panel_loginPage__3jMyE","login_box":"admin-panel_login_box__5-11I","background":"admin-panel_background__90fZv","adminPanel":"admin-panel_adminPanel__pWrQa"};